import { EventEmitter, Injectable } from '@angular/core';
import { IVisionHIS } from '../shared/hcr-lib/IVisionHis';
import { VisionHIS } from '../shared/hcr-lib/VisionHIS';
import { VisionHisDemo } from '../shared/hcr-lib/VisionHisDemo';
import { PatientApi } from './api-service/patient/patient-api';
import { IPatient, PatientsDto } from './api-service/patient/patientsDto';
import { EasyNotificationService } from './easy-notification.service';
import { UserCache } from './user-cache';
import { UserConfirmService } from './user-confirm.service';
import { allergyData, ddiData, medPrtData, nhiReq, nhiReqV2, nhiReqV2CSHIS5, nhiReqV2CSHIS6, specialData } from './api-service/hist/hist-api';
import { HcrConsoleComponent } from '../card-reader/hcr-console/hcr-console.component';
import { ConsoleIconComponent } from '../layout/header/icons/console-icon/console-icon.component';
import { LocalPrintService } from './local-print.service';
import { MatDialog } from '@angular/material/dialog';
import { LocalFileSelectorComponent } from '../shared/components/local-file-selector/local-file-selector.component';
import { ParameterApi } from './api-service/parameters/parameter-api';
import { NullOrEmptyTrim, onGetDateString } from '../shared/utilities';
import { DateHelper } from '../shared/helpers/date-helper';
import { LocalStoragesService } from './local-storages.service';
import { ClinicApi } from './api-service/clinic/clinic-api';
import { PACSReceiver } from '../shared/models/pACS-receiver';
import { HttpClient } from '@angular/common/http';
import { ClinicDataService } from './data-service/clinic-data-service';
import { HotKeyService, Priority } from './hotkey-service';
import { BaseConfig } from './base-config.service';
import { environment } from '../../environments/environment';
import { MainLayoutService } from '../layout/services/main-layout.service';
import { VisionHIS6 } from '../shared/hcr-lib/VisionHIS6';
import { SessionService } from './session.service';
import { MemoryCache } from './memory-cache-service';
import { DebugNotifyService } from './debug-notify.service';
import { OfflineData } from '../_offline/models/offline-reg-data';
import { ChisConsoleSocket, ChisWebViewBridgeService } from '../security/services/chis-webview-bridge.service';

export interface VisionApiResult {
  Id: string,
  Call: string,
  Successed: boolean,
  Returns: any,
  Code?: string
}
export interface LocalFileInfo {
  Name: string;
  FullName: string;
  IsDirectory: boolean;
  Children: LocalFileInfo[];
  Path: string;
  /** Base64 檔案內容 GetFullFile才有 */
  Content: string;
}
export interface ConsoleInfo {
  Identity: string;
  ComputerName: string;
  Config: any;
  DateTime: string;
  Mods: VersionInfo[];
  Printers: { [key: string]: { PaperName: string, Width: number, Height: number }[] }
  Version: string;
  IP: string;
  NetworkState?: string;
  InfoDate?: string;
  SAMInstalled?: boolean;
  CSHIS?: CshisIni;
  OfflinePatientPackageClinicCodes?: string[];
}

export enum CsHisReaderType {
  PCSC = 0,
  NonPCSC = 1,
}

export interface CshisIni {
  /** 讀卡機類型 */
  READER: CsHisReaderType;
  /** 連接埠，例如 COMX1 */
  COM: string;
  /** 是否啟用 HCA DLL */
  HCA: boolean;
  /** 是否顯示雲端安全模組主控台 */
  CSFSIM: boolean;
  /** 卡片變更時是否顯示訊息 */
  MSGSHOW: boolean;
  /** 醫事卡快速認證 */
  HPCFASTAUTH: boolean;
  /** 是否顯示讀卡機燈號視窗 */
  CSWATCH: boolean;
  /** 逾時秒數 */
  CSTIMEOUT: number;
  /** 是否自動 SAM 認證 */
  CSAUTOVSAM: boolean;
  /** 是否啟用離線認證 */
  CSOFFAUTH: boolean;
  /** 是否啟用遠端模式 */
  CSREMOTE: boolean;
  /** 結束主控台時是否保留 HIS 程式 */
  CLSCSFSIM: boolean;
}
export interface VersionInfo {
  Name: string;
  Ver: string;
}

export interface PaperSize {
  "Width": number, "Height": number, "PaperName": string, "Kind": string, "Landscape": boolean
}

@Injectable({
  providedIn: 'root'
})
export class HcrService {
  public static useWebApi = false;
  constructor(
    private mainlayoutService: MainLayoutService,
    private notificationService: EasyNotificationService,
    private userConfirmService: UserConfirmService,
    private localStorage: LocalStoragesService,
    private sessionService: SessionService,
    private memcache: MemoryCache,
    private patientApi: PatientApi, private paramApi: ParameterApi, private clinicApi: ClinicApi,
    private debugApi: DebugNotifyService,
    private matDialog: MatDialog,
    private httpClient: HttpClient,
    private clinicDataService: ClinicDataService,
    private hk: HotKeyService,
    private chisWebViewBridge: ChisWebViewBridgeService
  ) {
    //this.VisionApi = new VisionHIS6(this,this.httpClient);
    this.currentApi = new VisionHIS(this);
    this.VisionApi = this.currentApi;
    //this.VHCApi = new VisionVHIS(this, this.httpClient);
    // Ctrl+` 開關主控台=w=
    if (BaseConfig.isDebug) {
      this.hk.regist(Priority.Low, 'Ctrl', (k: string) => {
        if (k == '`') {
          this.OpenHcrConsole();
        }
      });
    }
    this.installBrowserLifecycleLog();
    this.sessionService.logoutEvent.subscribe(() => this.resetHcrDisconnectMonitor());

  }
  public hcrConsoleComp: HcrConsoleComponent;
  private consoleIconComponent: ConsoleIconComponent;
  private printService: LocalPrintService;
  private nhiWebApiError: boolean = true
  public SetConsoleIconComponent(comp: ConsoleIconComponent) {
    this.consoleIconComponent = comp;
    this.consoleIconComponent.isHcrDemo = this.isDemoMode;
    this.consoleIconComponent.UpdateConsoleState(this.isConnected);
    this.consoleIconComponent.nhiWebApiError = this.nhiWebApiError;
    this.consoleIconComponent.CsHisVer = this.VisionApi instanceof VisionHIS6 ? '6'
      : this.VisionApi instanceof VisionHIS ? '5' : '';
  }
  public SetHcrConsoleComponent(comp: HcrConsoleComponent) {
    this.hcrConsoleComp = comp;
    this.hcrConsoleComp.isHcrDemo = this.isDemoMode;
    this.hcrConsoleComp.UpdateConsoleInfo(this.isConnected);
    this.hcrConsoleComp.licenseMsg = this.licenseMsg;
    this.hcrConsoleComp.licenseStatus = this.licenseStatus;
  }
  /** 開啟或關閉主控台 */
  public OpenHcrConsole() {
    this.consoleIconComponent.showHCRDialog = !this.consoleIconComponent.showHCRDialog;
  }
  public SetPrintService(printService: LocalPrintService) {
    this.printService = printService;
    if (this.isConnected) {
      this.printService.initialPrintClient();
      this.login();
    }
  }
  public GetCsHisApi(): IVisionHIS {
    return this.VisionApi;
  }
  public VisionApi: IVisionHIS;
  private demoApi: VisionHisDemo;
  private currentApi: IVisionHIS;
  //public VHCApi: VisionVHIS;
  private idGenerator: IdGenerator = new IdGenerator();
  private ws: ChisConsoleSocket;
  private connectPromise: Promise<boolean>;
  private messagePromise: Promise<string>;
  private closePromise: Promise<CloseEvent>;

  private messageReciever: Map<string, (string) => void> = new Map();
  private isConnected = false;
  private isCardInsert = false;
  public isDemoMode = false;
  private autoReconnect = true;
  private reconnectInterval = 10000;
  private readonly hcrDisconnectWindowMs = 10 * 60 * 1000;
  private readonly hcrDisconnectNotifyCooldownMs = 10 * 60 * 1000;
  private readonly maxHcrDisconnectNotifications = 3;
  private hcrDisconnectTimes: number[] = [];
  private hcrDisconnectSessionKey = '';
  private hcrDisconnectNotifyCount = 0;
  private hcrDisconnectLastNotifyAt = 0;
  private wsUrl = 'ws://127.0.0.1:23675/VisionService';
  private wsConnSeq = 0;
  private browserLifecycleLogInstalled = false;
  private readonly wsTraceId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  private pendingClientLogs: { logLevel: 'Error' | 'Warning' | 'Info', isSuccess: boolean, message: string, dt: Date }[] = [];
  private isFlushingClientLogs = false;
  private readonly maxPendingClientLogs = 500;
  private medCloudV2Url = 'https://medcloudws2.nhi.gov.tw/api/imie5000/GetMedPrtData';//控制軟體5.x
  private medCloudV2CSHIS5Url = this.medCloudV2Url;
  private medCloudV2CSHIS6Url = 'https://medcloudws2.nhi.gov.tw/api/imie5000/GetMedPrtInfo';//控制軟體6.0


  licenseMsg = '';
  licenseStatus = false;
  //public OnHCChange: EventEmitter<boolean> = new EventEmitter();
  //public OnHPCChange: EventEmitter<boolean> = new EventEmitter();
  onDemoMode = new EventEmitter<boolean>();
  onVisionAPIChanged = new EventEmitter<boolean>();
  onHCCardChanged = new EventEmitter<boolean>();
  onConnected = new EventEmitter<boolean>()
  onOpened = new EventEmitter<boolean>(true)
  public setVisionApi(api: IVisionHIS) {
    this.VisionApi = api;
    this.onVisionAPIChanged.emit();
    this.hcrConsoleComp?.UpdateConsoleInfo(true);
    this.consoleIconComponent?.UpdateConsoleState(true);
  }
  public onPrinterProgress: EventEmitter<PrintProgressModel> = new EventEmitter();
  public OfflineWaitingListChanged: EventEmitter<OfflineData[]> = new EventEmitter();
  //onDemoPatientChanged = new EventEmitter<PatientsDto>();
  public get ConnectStatus(): boolean {
    return this.isConnected || this.isDemoMode;
  }
  public get HasCard(): boolean {
    return this.isCardInsert || this.isDemoMode;
  }
  public get IsVer6() {
    return this.VisionApi instanceof VisionHIS6;
  }
  public get IsVer5() {
    return this.VisionApi instanceof VisionHIS;
  }
  public get VisionHis6() {
    if (this.IsVer6) {
      return this.VisionApi as VisionHIS6;
    }
    return null;
  }
  private _openRsv: (b) => void = null;
  public Connect(fromAutoReconnect = true) {

    var _rjt: (r) => void;
    var _rsvClose: (b) => void;
    var _rjtClose: (r) => void;
    this.connectPromise = new Promise<boolean>((resolve, reject) => {
      this._openRsv = resolve;
      _rjt = reject;
    });

    this.closePromise = new Promise<CloseEvent>((resolve, reject) => {
      _rsvClose = resolve;
      _rjtClose = reject;
    });
    try {
      this.wsConnSeq++;
      const connectSeq = this.wsConnSeq;
      const connectStart = Date.now();
      this.logWsDiag('Info', true, '連線嘗試', {
        connectSeq,
        fromAutoReconnect,
        autoReconnect: this.autoReconnect,
        reconnectInterval: this.reconnectInterval,
        wsUrl: this.wsUrl
      });
      const bridgeSocket = this.chisWebViewBridge.createConsoleSocket();
      this.ws = bridgeSocket || new WebSocket(this.wsUrl);
      const isNativeWebSocket = !bridgeSocket;
      let connectionOpenedAt = 0;

      this.ws.onopen = async (ev: Event) => {
        connectionOpenedAt = Date.now();
        this.logWsDiag('Info', true, '連線開啟', {
          connectSeq,
          elapsedMs: connectionOpenedAt - connectStart,
          fromAutoReconnect,
          eventType: ev?.type
        });
        this.isConnected = true;
        if (this.onOpened.observers.length > 0) {
          await this.onOpened.emit(true)
        } else {
          await this.onConnectionOpened(fromAutoReconnect);
        }
      }
      this.ws.onerror = async (ev: Event) => {
        this.logWsDiag('Error', false, '連線發生錯誤', {
          connectSeq,
          eventType: ev?.type,
          elapsedMs: Date.now() - connectStart,
          fromAutoReconnect
        });
        if (fromAutoReconnect) {
          this.notificationService.showError("與展望主控台連線失敗")
          try {
            var permission = await navigator.permissions.query({ name: 'local-network-access' } as any)
            if (permission.state == 'denied') {
              await this.userConfirmService.showAlert('需要允許瀏覽器權限',
                `<div style="display:flex;width: 600px;column-gap: 20px;">
                  <div style="flex-grow:1;font-size: 18px;display: flex;flex-direction: column;">
                    <div class="mb-2">
                      👉<span class="fw-bold text-primary">請參考圖片</span>進行以下操作：
                    </div>
                    <div class="ps-2">
                      <div>1️⃣ 點擊<span class="fw-bold text-danger">網址列左側的圖示</span></div>
                      <div>2️⃣ 開啟<span class="fw-bold text-success">「區域網路」</span></div>
                      <div>3️⃣ 開啟<span class="fw-bold text-success">「裝置上的應用程式」</span></div>
                      <div>4️⃣ <span class="fw-bold text-danger">關閉</span>設定框</div>
                      <div>5️⃣ 依提示<span class="fw-bold text-primary">重新載入網頁</span></div>
                    </div>
                  </div>
                  <img src="assets/images/chrome-local-network-access-permissions.png">
                </div>`, { htmlMsg: true, fitContent: true })
            }
          } catch (e) {

          }
        }
        _rjt(ev);
      }
      this.ws.onclose = async (ev: CloseEvent) => {
        this.logWsDiag('Warning', ev?.wasClean ?? false, '連線關閉', {
          connectSeq,
          code: ev?.code,
          reason: ev?.reason,
          wasClean: ev?.wasClean,
          elapsedMs: Date.now() - connectStart,
          connectedUptimeMs: connectionOpenedAt > 0 ? Date.now() - connectionOpenedAt : null,
          willAutoReconnect: this.autoReconnect,
          reconnectInterval: this.reconnectInterval
        });
        if (isNativeWebSocket && connectionOpenedAt > 0 && connectSeq === this.wsConnSeq &&
          ev.code !== 4000 && ev.code !== 4001 && this.autoReconnect) {
          this.trackHcrDisconnect(ev, connectSeq, connectionOpenedAt);
        }
        this.isConnected = false;
        if (ev.code == 4000) {
          this.notificationService.showError("展望主控台連線中斷(" + ev.reason + ")");
        }
        if (this.autoReconnect) {
          this.logWsDiag('Info', true, '排程重連', {
            connectSeq,
            afterMs: this.reconnectInterval
          });
          setTimeout(() => {
            this.logWsDiag('Info', true, '開始重連', {
              prevConnectSeq: connectSeq
            });
            this.Connect(false).catch(e => { });
          }, this.reconnectInterval);
        }
        this.debugApi
        //this.OnClosed.emit(ev.reason);
        this.hcrConsoleComp?.UpdateConsoleInfo(false);
        this.consoleIconComponent?.UpdateConsoleState(false);
        await this.printService.initialPrintClient();
        //await this.login();
        _rsvClose(ev);
      }
      this.ws.onmessage = async (ev: MessageEvent) => {
        var result: VisionApiResult = JSON.parse(ev.data);
        if (result.Id == '-999') {
          switch (result.Call) {
            case 'HCCardInsert':
              //this.OnHCChange.emit(true);
              this.hcrConsoleComp.HpCardChanged(true);
              this.notificationService.showInfo('[健保卡] 卡片插入');
              this.isCardInsert = true;
              this.onHCCardChanged.emit(true);
              break;
            case 'HCCardRemove':
              //this.OnHCChange.emit(false);
              this.hcrConsoleComp.HpCardChanged(false);
              this.notificationService.showInfo('[健保卡讀卡機] 卡片移出');
              this.isCardInsert = false;
              this.onHCCardChanged.emit(false);
              break;
            case 'HPCCardInsert':
              //this.OnHPCChange.emit(true);
              this.hcrConsoleComp.HpcCardChanged(true);
              this.notificationService.showInfo('[醫事人員卡]插入');
              this.isConnected = true;
              break;
            case 'HPCCardRemove':
              //this.OnHPCChange.emit(false);
              this.hcrConsoleComp.HpcCardChanged(false);
              this.notificationService.showInfo('偵測到醫師卡移出');
              this.isConnected = false;
              break;
            case 'CardReaderInsert':
              this.notificationService.showInfo('偵測到讀卡機[' + result.Returns + ']插入');
              this.isConnected = true;
              break;
            case 'CardReaderRemoved':
              this.notificationService.showInfo('偵測到讀卡機[' + result.Returns + ']移出');
              this.isConnected = false;
              break;
            // AppConsoleOpen
            case 'PrinterInit':
              //this.OnPrinterInit.emit();
              await this.printService.initialPrintClient();
              await this.login();
              this.notificationService.showInfo('卡機主控台啟動了');
              break;
            case 'PrinterProgressChanged':
              //var data = result.Returns as { Name: string, Status: string, Printer: string }[];
              console.log(result.Returns);
              this.onPrinterProgress.emit(new PrintProgressModel(result.Returns));
              break;
            case 'Message':
              this.notificationService.showInfo(result.Returns);
              break;
            case 'OfflineWaitingListChanged':
              this.OfflineWaitingListChanged.emit(result.Returns);
              break;
          }
        } else {
          var rs = this.messageReciever.get(result.Id);
          // 接完清掉
          this.messageReciever.delete(result.Id);
          rs(result);
        }

      }
      return this.connectPromise;
    } catch (ex) {
      this.logWsDiag('Error', false, '連接發生例外', {
        fromAutoReconnect,
        exception: ex?.toString?.() ?? ex
      });
      return Promise.resolve(false)
    }

  }
  public async onConnectionOpened(fromAutoReconnect: boolean) {
    if (fromAutoReconnect) {
      this.notificationService.showInfo("已與展望主控台重新連線")
    } else {
      this.notificationService.showInfo("與展望主控台連線成功")
    }

    //使用者登入
    await this.login();
    await this.printService.initialPrintClient();

    await this.flushPendingClientLogs();

    var info = await this.logConsoleInfo()
    var csHisVer = info.Config.CSHisVer;
    var nhiReady = true;
    // 要先run
    if (!this.isDemoMode && csHisVer) {
      var runRet = await this.RunNHI();
      nhiReady = runRet.Successed;
      if (nhiReady) {
        if (csHisVer == '5157') {
          this.currentApi = new VisionHIS(this);
        } else if (csHisVer == '60') {
          var api = new VisionHIS6(this, this.httpClient);
          this.currentApi = api;
          await api.Initial();
        }
        this.setVisionApi(this.currentApi);
      } else {
        await this.userConfirmService.showAlert(
          '健保讀卡機控制軟體異常',
          runRet.Returns || '無法啟動雲端控制軟體'
        );
      }
    }
    try {
      if (nhiReady) {
        // 自動切換COMX
        var changeComXRet = await this.changeCOMX(UserCache.getLoginUser().Clinic.NHICode)
        // 主控台沒更新會失敗，先不提示
        if (!changeComXRet.Successed) {
          //this.notificationService.showWarning(changeComXRet.Returns, true);
        }
        //自動驗SAM
        var ret = await this.VisionApi.VerifySAMDC();
        if (ret.StatusCode != 0) {
          this.notificationService.showWarning('SAM自動驗證失敗(' + ret.ErrorMsg + ')', true);
        }
        if (this.IsVer6) {
          this.VisionApi.GetCardStatusHC().then(x => this.isCardInsert = x.Data?.startsWith('健保卡') ?? false);
        }
        else if (this.IsVer5) {

          this.VisionApi.GetCardStatusHC().then(x => this.isCardInsert = x.Data?.startsWith('健保 IC 卡') ?? false);
        }
      }
    } catch (ex) {
      await this.userConfirmService.showAlert('健保讀卡機控制軟體異常', ex);
    }

    this.hcrConsoleComp?.UpdateConsoleInfo(nhiReady);
    this.consoleIconComponent?.UpdateConsoleState(true);


    //this.OnConnected.emit();
    this._openRsv(true);
    // 主控台連上的時候偵測一次WebAPI通不通，通則將useWebAPI打開，否則關閉(走DLL)
    let url = 'https://medvpndti.nhi.gov.tw/cshis/V1000/hisGetTreatNumNoICCard2';
    this.sendMsg({
      Call: 'SendFromUrl', Args: {
        Url: url, Content: JSON.stringify({
          sSamid: '', sHospId: '', sClientrandom: '', sSignature: '', sPatientId: ''
        })
      }
    }).then(v => {
      var st = v.Returns.StatusCode
      if (st !== undefined) {
        // API通
        HcrService.useWebApi = true;
        this.nhiWebApiError = false;
        if (this.consoleIconComponent) {
          this.consoleIconComponent.nhiWebApiError = false;
        }

      }
    });
    this.onConnected.emit(true)
  }
  public ConnectForBgPrint(cb: (d: ConsoleInfo) => void, cber: (ev: Event) => void) {
    try {
      console.log('connection to ws://127.0.0.1:23675/VisionService')
      this.logWsDiag('Info', true, 'bg-connect-attempt', { wsUrl: this.wsUrl });
      this.ws = this.chisWebViewBridge.createConsoleSocket() || new WebSocket(this.wsUrl);
      this.ws.onopen = async (ev: Event) => {
        this.logWsDiag('Info', true, 'bg-ws-open', { eventType: ev?.type });
        this.isConnected = true;
        await this.login()
        await this.flushPendingClientLogs();
        await this.Print(0, {});
        var ret = await this.sendMsg({ Call: 'GetInfo', Args: {} });
        if (ret.Successed) {
          var info = ret.Returns as ConsoleInfo;
          cb(info);
        }
      }
      this.ws.onerror = (ev: Event) => {
        this.logWsDiag('Error', false, 'bg-ws-error', { eventType: ev?.type });
        cber(ev);
      }
      this.ws.onclose = (ev: CloseEvent) => {
        this.logWsDiag('Warning', ev?.wasClean ?? false, 'bg-ws-close', {
          code: ev?.code,
          reason: ev?.reason,
          wasClean: ev?.wasClean,
          reconnectInterval: this.reconnectInterval
        });
        this.isConnected = false;
        setTimeout(() => {
          this.logWsDiag('Info', true, 'bg-ws-reconnect-trigger', { afterMs: this.reconnectInterval });
          this.ConnectForBgPrint((a) => { }, cber)
        }, this.reconnectInterval);
      }
      this.ws.onmessage = (ev: MessageEvent) => {
        var result: VisionApiResult = JSON.parse(ev.data);
        if (result.Id == '-999') {
          switch (result.Call) {
            case 'Message':
              this.notificationService.showInfo(result.Returns);
              break;
          }
        } else {
          var rs = this.messageReciever.get(result.Id);
          // 接完清掉
          this.messageReciever.delete(result.Id);
          rs(result);
        }

      }
    } catch (ex) {
    }

  }
  public Close(fromUser = true) {
    this.logWsDiag('Info', true, '連線手動關閉', {
      fromUser,
      autoReconnectBeforeClose: this.autoReconnect,
      wsState: this.ws?.readyState
    });
    if (fromUser) {
      this.autoReconnect = false;
      this.ws.close(4000, '使用者關閉連線');
    } else {
      this.ws.close(4001, '雲端控制軟體版本切換，重新連線');
    }


    return this.closePromise;
  }
  private async login() {
    const obj: any = {};
    const loginUser = UserCache.getLoginUser();
    obj.ClinicId = loginUser.Clinic.Id;
    obj.ClinicCode = loginUser.Clinic.Code;
    obj.CompanyId = loginUser.Clinic.CompanyId;
    obj.ClinicName = loginUser.Clinic.Name;
    obj.Account = loginUser.Account;
    obj.CompanyCode = loginUser.CompanyCode;
    obj.Name = loginUser.Name;
    obj.ChisSessionId = this.chisWebViewBridge.activeLoginSessionId;
    obj.Token = loginUser.AuthToken;
    obj.UserId = loginUser.UserId;
    const isForceDisableDebugMode = localStorage.getItem('DebugMode') === 'F';
    obj.IsSuper = isForceDisableDebugMode ? false : loginUser.IsSuper;
    obj.IsDemo = isForceDisableDebugMode
      ? false
      : (environment.envName || '').toLowerCase() !== 'prodtw';
    obj.ApiUrl = BaseConfig.getConfig().webApi.hisBaseUrl;

    var ret = await this.sendMsg({
      Call: 'Login',
      Args: obj
    });
    this.licenseMsg = ret.Returns;
    this.licenseStatus = ret.Successed;
    if (this.hcrConsoleComp) {
      this.hcrConsoleComp.licenseMsg = ret.Returns;
      this.hcrConsoleComp.licenseStatus = ret.Successed;
    }

    await this.Print(0, obj);

  }

  public sendMsg(data: { Call: string, Args?: any }) {
    try {
      if (this.isConnected && this.ws.readyState == 1) {
        // console.log('sendMsg >>>>>', data);
        var id = this.idGenerator.next();
        var promise = new Promise<VisionApiResult>((rs, rj) => {
          this.messageReciever.set(id.toString(), rs)
        });
        var sendObj = Object.assign({ id: id }, data)
        //data.id = id;
        this.ws.send(JSON.stringify(sendObj));
        return promise;
      } else {
        return Promise.resolve<VisionApiResult>({ 'Id': '0', 'Call': data.Call, 'Successed': false, 'Returns': '未建立連線' });
      }
    } catch (ex) {
      return Promise.resolve<VisionApiResult>({ 'Id': '0', 'Call': data.Call, 'Successed': false, 'Returns': '發送失敗' + ex });
    }

  }
  /**
   * 切換版本
   * @param ver
   * @returns
   */
  public async changeApiVersion(ver: string) {
    var ret = await this.sendMsg({ Call: 'ChangeVer', Args: { 'path': '', 'ver': ver } });
    return ret;
  }
  public async RunNHI() {
    var ret = await this.sendMsg({ Call: 'RunNHI', Args: {} });
    if (ret.Code === 'ACT-VISIONHCR-004' || ret.Returns === "不支援此方法'RunNHI'") {
      return { ...ret, Successed: true, Returns: null, Code: '' };
    }
    return ret;
  }
  public async changeCOMX(hCode: string) {
    var ret = await this.sendMsg({ Call: 'ChangeCOMX', Args: { 'HCode': hCode } });
    return ret;
  }
  public async getCOMXList() {
    var ret = await this.sendMsg({ Call: 'GetCOMXList', Args: {} });
    if (ret.Successed) {
      return ret.Returns as { Name: string, ComX: string, NHICode: string, CardNo: string }[];
    } else {
      return [];
    }
  }
  async setConsoleConfig(info: ConsoleInfo) {
    var ret = await this.sendMsg({ Call: 'SetConfig', Args: { Config: info.Config } });
    if (ret.Successed) {
      this.notificationService.showSuccess('套用完成')
    } else {
      this.notificationService.showError(ret.Returns)
    }

  }
  infoSnapshot: ConsoleInfo = null;
  // 最低支援版本
  supportVersion(version: string) {
    var currentVer = this.infoSnapshot?.Mods.find(x => x.Name == 'Vision.PrintConsole').Ver;
    if (!currentVer || currentVer.split('.').length != 3) {
      return false;
    }
    // A.B.C拉齊成 00A00B00C
    var cVers = currentVer.split('.').map(x => x.padStart(3, '0')).join();
    var nVers = version.split('.').map(x => x.padStart(3, '0')).join();
    return cVers > nVers;
  }
  async logConsoleInfo(): Promise<ConsoleInfo> {
    var ret = await this.sendMsg({ Call: 'GetInfo', Args: {} });
    if (ret.Successed) {
      var info = ret.Returns as ConsoleInfo;
      info.InfoDate = new Date().toDateString();
      var localinfo: ConsoleInfo = this.localStorage.getItem('ConsoleInfo') ?? {}
      var info2 = Object.assign({}, info);
      info2.DateTime = '';
      localinfo.DateTime = '';
      if (JSON.stringify(info2) != JSON.stringify(localinfo)) {
        this.localStorage.setItem('ConsoleInfo', info);

        // 不影響UI資料呈現，背景執行
        setTimeout(async () => {
          var speed = await this.debugApi.SpeedTest();
          var speedUpload = speed.uploadSpeed > 1024 ? (speed.uploadSpeed / 1024).toFixed(1) + 'MB/s' : (speed.uploadSpeed).toFixed(1) + 'KB/s';
          var speedDownload = speed.downloadSpeed > 1024 ? (speed.downloadSpeed / 1024).toFixed(1) + 'MB/s' : (speed.downloadSpeed).toFixed(1) + 'KB/s';
          info.NetworkState = `網速: ↑${speedUpload}, ↓${speedDownload} \n延遲: ${speed.roundTripTime}ms (↑${speed.toServerDelay},↓${speed.fromServerDelay})`
          await this.clinicApi.UpdateConsoleInfo(info)
        }, 0);

        //網路品質

        //await save info
      }
      this.infoSnapshot = info;
      return info;
    }
    return null;
  }
  public async Update() {
    var ret = await this.sendMsg({ Call: 'Update', Args: {} });
    return ret;
  }
  public async Reload() {
    var ret = await this.sendMsg({ Call: 'Reload', Args: {} });
    return ret;
  }
  /**
   *
   * @param path 相對路徑 from 主控台資料夾\\Files\\
   * @param content
   * @param zipped
   * @param encode
   * @returns
   */
  public async SaveTextAs(path: string, content: string, zipped: boolean = false, encode = 'utf8') {
    var ret = await this.sendMsg({
      Call: 'SaveTextAs', Args: {
        Path: path,
        Content: content,
        Zip: zipped,
        Encode: encode
      }
    });
    return ret;
  }

  public async PathCheck(path: string, timeoutSec: number) {
    var ret = await this.sendMsg({
      Call: 'PathCheck', Args: {
        Path: path,
        Timeout: timeoutSec
      }
    });
    return ret;
  }
  public async getDirectory(): Promise<LocalFileInfo> {
    var ret = await this.sendMsg({ Call: 'GetFiles', Args: {} });
    var fileInfos = ret.Returns as LocalFileInfo
    return fileInfos;
  }

  /** 儲存檔案，如果系統參數有開添加密碼，則會壓縮為zip檔 */
  public async SaveTextAsZipIfPwd(path: string, content: string, encode = 'utf8') {
    var sys001 = await this.clinicDataService.getParam("SYS101");
    var ret = await this.sendMsg({
      Call: 'SaveTextAs', Args: {
        Path: path,
        Content: content,
        Zip: sys001.SaveFileAddPassword,
        T: sys001.SaveFileAddPassword ? UserCache.getLoginUser().ConsoleToken : '',
        Encode: encode
      }
    });
    return ret;
  }

  public async SaveBlobAs(path: string, blob: Blob, showOpenFolder = true) {
    let arrayBuffer = await this.blobToArrayBuffer(blob);
    let uint8Array = new Uint8Array(arrayBuffer);
    var ret = await this.sendMsg({
      Call: 'SaveBlobAs', Args: {
        Path: path,
        Blob: Array.from(uint8Array),
      }
    });
    if (showOpenFolder) {
      await this.ConfirmOpenDir('下載完成', '檔案已下載至\n' + ret.Returns, ret.Returns);
    } else {
      //this.notificationService.showInfo('檔案已下載至\n' + ret.Returns,true);
    }
    return ret;
  }
  public async CachesSave(content: string) {
    var ret = await this.sendMsg({
      Call: 'CachesSave', Args: {
        Data: content,
      }
    });
    return ret;
  }
  public async CachesRead() {
    var ret = await this.sendMsg({
      Call: 'CachesRead', Args: {
      }
    });
    return ret.Returns as string;
  }
  /** 影像系統專用 */
  public async SaveBlobToHistImage(folder: string, blob: Blob, ext: string) {
    let arrayBuffer = await this.blobToArrayBuffer(blob);
    let uint8Array = new Uint8Array(arrayBuffer);
    var ret = await this.sendMsg({
      Call: 'SaveBlobToHistImage', Args: {
        Path: folder,
        Blob: Array.from(uint8Array),
        Ext: ext
      }
    });

    return ret;
  }
  private blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  }
  public async ExportDataToExcel(sheetName: string, data: any[], isOpenDownDialog = true, isMeta = false, folderName = '') {
    var cols: string[] = []
    for (let row of data) {
      for (let c in row) {
        if (!cols.some(cl => cl == c)) {
          cols.push(c)
        }
      }
    }
    var header = `<tr>${cols.map(x => `<td>${x}</td>`).join('\n')}</tr>`
    var body = data.map(d => `<tr>${cols.map(x => `<td>${d[x] ?? ''}</td>`).join('\n')}</tr>`)
    var rows = [header, ...body];
    return this.ExportTableToExcel(sheetName, rows.join('\n'), isOpenDownDialog, isMeta, folderName)
  }
  /** 轉excel isOpenDownDialog(產檔案後告訴檔案位置 預設為開啟) */
  public async ExportTableToExcel(sheetName: string, html: string, isOpenDownDialog = true, isMeta = false, folderName = '') {
    let template =
      `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
      <style>.excel-format-text { mso-number-format:"\\@"; }</style>
      <!--[if gte mso 9]>
        <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>{worksheet}</x:Name>
                        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                    </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
        </xml>
      <![endif]-->
      </head>
      <body>
        <table>{table}</table>
      </body>
    </html>`;

    if (isMeta && this.getChromeVersion() >= 130) {
      template =
        `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
      <meta http-equiv=Content-Type content="text/html; charset=BIG5">
      <meta name=ProgId content=Excel.Sheet>
      <style>.excel-format-text { mso-number-format:"\\@"; }</style>
      <!--[if gte mso 9]>
        <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>{worksheet}</x:Name>
                        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                    </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
        </xml>
      <![endif]-->
      </head>
      <body>
        <table>{table}</table>
      </body>
    </html>`;
    }

    const format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };
    const ctx = { worksheet: sheetName, table: html };
    var content = format(template, ctx);

    var fileName = sheetName + '_' + onGetDateString(new Date(), false, '', false) + DateHelper.getTimeString(new Date(), '', true) + `.xls`;
    var ret = await this.SaveTextAsZipIfPwd((!NullOrEmptyTrim(folderName) ? folderName : sheetName) + '\\' + fileName, content)
    if (isOpenDownDialog) await this.ConfirmOpenDir('下載完成', '檔案已下載至\n' + ret.Returns, ret.Returns);

  }

  getChromeVersion() {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : -1;
  }

  public async ExportTableToExcelWithCss(sheetName: string, html: string, style: string) {
    let content =
      `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
      <!--[if gte mso 9]>
        <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>${sheetName}</x:Name>
                        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                    </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
        </xml>
      <![endif]-->
        ${style}
      </head>
      <body>
        ${html}
      </body>
    </html>`;


    var fileName = sheetName + '_' + onGetDateString(new Date(), false, '', false) + DateHelper.getTimeString(new Date(), '', true) + `.xls`;
    var ret = await this.SaveTextAsZipIfPwd(sheetName + '\\' + fileName, content, "utf-8")
    await this.ConfirmOpenDir('下載完成', '檔案已下載至\n' + ret.Returns, ret.Returns);

  }

  public async ConfirmOpenDir(title: string, msg: string, path: string) {
    if ((await this.userConfirmService.showConfirm({
      title: title,
      msg: msg,
      // width: 300,
      fitContent: true,
      textYes: '開啟資料夾位置',
      textNo: '確認'
    })) == true) {
      var dirRet = await this.sendMsg({
        Call: 'OpenDir', Args: {
          Path: path,
        }
      })

      if (dirRet.Successed == false) {
        this.notificationService.showError(`資料夾開啟失敗(${dirRet.Returns})，請確定您的主控台是否有更新。`)
      }

    }
  }
  public async OpenDir(path: string) {
    var ret = await this.sendMsg({
      Call: 'OpenDir', Args: {
        Path: path,
      }
    });
    return ret;
  }

  public GetMedCloudV2Url() {
    //demo mode也跑6.0
    if (this.IsVer5) {
      return this.medCloudV2CSHIS5Url;
    } else {
      return this.medCloudV2CSHIS6Url;
    }
  }

  /** 雲端查詢1.0 跨院 */
  public async GetMedPrtData(content: nhiReq) {
    var ret = await this.sendMsg({ Call: 'MedCloud', Args: { api: 'GetMedPrtData', Content: content } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as medPrtData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 跨院 */
  public async GetMedPrtDataV2(content: nhiReqV2) {
    let url = this.medCloudV2Url;
    let contentExt = new nhiReqV2CSHIS5(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as medPrtData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 或 6.0 跨院 */
  public async GetMedPrtExt(content: nhiReqV2) {
    let url = this.GetMedCloudV2Url();
    let contentExt = this.IsVer5 ? new nhiReqV2CSHIS5(content) : new nhiReqV2CSHIS6(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as medPrtData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢1.0 過敏 */
  public async GetAllergyData(content: nhiReq) {
    var ret = await this.sendMsg({ Call: 'MedCloud', Args: { api: 'GetAllergyData', Content: content } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as ddiData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 過敏 */
  public async GetAllergyDataV2(content: nhiReqV2) {
    let url = this.medCloudV2Url;
    let contentExt = new nhiReqV2CSHIS5(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as allergyData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 或 6.0 過敏 */
  public async GetAllergyExt(content: nhiReqV2) {
    let url = this.GetMedCloudV2Url();
    let contentExt = this.IsVer5 ? new nhiReqV2CSHIS5(content) : new nhiReqV2CSHIS6(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as allergyData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢1.0 交互 */
  public async GetDDIData(content: nhiReq) {
    var ret = await this.sendMsg({ Call: 'MedCloud', Args: { api: 'GetDDIData', Content: content } });
    if (ret.Successed) {
      console.log('GetDDIData >>>>>', ret);
      return JSON.parse(ret.Returns) as ddiData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 交互 */
  public async GetDDIDataV2(content: nhiReqV2) {
    let url = this.medCloudV2Url;
    let contentExt = new nhiReqV2CSHIS5(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as ddiData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 或 6.0 交互 */
  public async GetDDIExt(content: nhiReqV2) {
    let url = this.GetMedCloudV2Url();
    let contentExt = this.IsVer5 ? new nhiReqV2CSHIS5(content) : new nhiReqV2CSHIS6(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as ddiData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 特殊給付限制 */
  public async GetSpecialDataV2(content: nhiReqV2) {
    let url = this.medCloudV2Url;
    let contentExt = new nhiReqV2CSHIS5(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as specialData;
    } else {
      throw ret.Returns;
    }
  }

  /** 雲端查詢2.0 + 控制軟體5.x 或 6.0 特殊給付限制 */
  public async GetSpecialExt(content: nhiReqV2) {
    let url = this.GetMedCloudV2Url();
    let contentExt = this.IsVer5 ? new nhiReqV2CSHIS5(content) : new nhiReqV2CSHIS6(content);
    var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: JSON.stringify(contentExt) } });
    if (ret.Successed) {
      return JSON.parse(ret.Returns) as specialData;
    } else {
      throw ret.Returns;
    }
  }

  public async OpenUrl(path: string) {
    var ret = await this.sendMsg({ Call: 'OpenUrl', Args: { Url: path } });
    return ret;
  }
  public async GetCardReaderInfo() {
    var ret = await this.sendMsg({ Call: 'GetCardReaderInfo', Args: {} });
    return ret;
  }
  public async ReloadCardReaderInfo() {
    var ret = await this.sendMsg({ Call: 'GetCardReaderInfo', Args: { reload: true } });
    return ret;
  }
  public async PrintTest() {
    var data = [{ "CMSformat": { "CMS": { "UIType": "Page", "Title": "掛號單", "Layout": "one", "Children": [{ "UIType": "Form", "Title": "掛號單", "Children": [{ "UIType": "Node", "Title": "", "Layout": "one", "Children": [{ "UIType": "Node", "Title": "病歷編號", "Layout": "inline", "ShowLabel": true, "TitleWidth": 10, "Children": [{ "UIType": "Control", "Title": "病例編號", "Layout": "NoLabel", "Type": 0, "Width": 4, "ColValue": "0987632145" }] }, { "UIType": "Node", "Title": "", "Layout": "inline", "LayoutParams": "3", "ShowLabel": true, "TitleWidth": 10, "Children": [{ "UIType": "Control", "Title": "患者姓名", "Layout": "inline", "Type": 0, "Width": 2, "ColValue": "林木森" }, { "UIType": "Control", "Title": "年齡", "Layout": "inline", "Type": 0, "Width": 1, "ColValue": "18" }] }, { "UIType": "Node", "Title": "", "Layout": "inline", "ShowLabel": true, "TitleWidth": 10, "LayoutParams": "3", "Children": [{ "UIType": "Control", "Title": "看診日期", "Layout": "inline", "Type": 2, "Width": 2, "ColValue": "2022/04/01" }, { "UIType": "Control", "Title": "時段", "Layout": "inline", "Type": 0, "Width": 1, "ColValue": "夜診" }] }, { "UIType": "Node", "Title": "診間", "Layout": "inline", "LayoutParams": "3", "ShowLabel": true, "TitleWidth": 10, "Children": [{ "UIType": "Control", "Title": "診間", "Layout": "NoLabel", "Type": 0, "Width": 2, "ColValue": "第零診間" }, { "UIType": "Control", "Title": "醫師", "Layout": "inline", "Type": 0, "Width": 1, "ColValue": "王壬撫" }] }, { "UIType": "Node", "Title": "候診編號", "Layout": "inline", "LayoutParams": "3", "ShowLabel": true, "TitleWidth": 10, "Children": [{ "UIType": "Control", "Title": "候診編號", "Layout": "NoLabel", "Type": 0, "Width": 2, "ColValue": "6666" }, { "UIType": "Control", "Title": "", "Layout": "NoLabel", "Type": 1, "Width": 1 }] }, { "UIType": "Node", "Title": "備註", "Layout": "inline", "LayoutParams": "3", "ShowLabel": true, "TitleWidth": 10, "Children": [{ "UIType": "Control", "Title": "備註", "Layout": "NoLabel", "Type": 0, "Width": 3, "ColValue": "無" }] }, { "UIType": "Node", "Title": "聯絡方式", "Layout": "inline", "ShowLabel": true, "TitleWidth": 10, "LayoutParams": "3", "Children": [{ "UIType": "Control", "Title": "地址", "Layout": "inline", "Type": 0, "Width": 2, "ColValue": "超北市北海區切他中路44巷87號1樓" }, { "UIType": "Control", "Title": "電話", "Layout": "inline", "Type": 0, "Width": 1, "ColValue": "(02)34567890" }] }] }] }] }, "OPTS": {} }, "ReportBaseDTOByList": null, "Agency": "展望診所(新)", "Title": "掛號單", "BeginDate": "0001-01-01T00:00:00", "BeginDateStringFormat": "", "EndDate": "0001-01-01T00:00:00", "EndDateStringFormat": "", "Sex": "男", "CaseDateStringFormat": "109/06/12", "Name": "微積分", "BirthDayStringFormat": "089/08/09", "Age": 21, "PatientNo": "", "MainDiagnosis": "" }];

    //[{"PatientId":10024,"Title":"全民健康保險居家照護四個月評值結果表","Sex":"女","Name":"彭婷婷","BirthDay":" 067 年 07 月 14 日","CId":"N1234","ApplyDate":"     年    月    日","EvaluationDate":"     年    月    日"}]
    var url = "https://devcorereport.azurewebsites.net/CMSMgmt/CMSReport/CMSRecord";
    return await this.Print(1, data)
  }
  public async Print(reportType: number, data: any, subPrinter: number[] = null) {
    var ret = await this.sendMsg({ Call: 'Printer', Args: { 'ReportType': reportType, 'Args': data, SubPrinter: subPrinter } });
    return ret;
  }

  public async PdfMerger(path: string, reports: MergePdfReport[]) {
    var ret = await this.sendMsg({ Call: 'PdfMerger', Args: { 'Path': path, 'Reports': reports } });
    return ret;
  }

  public async CabCompress(path: string, files: string[]) {
    var ret = await this.sendMsg({ Call: 'CabCompress', Args: { 'Path': path, 'Files': files } });
    return ret;
  }


  public async GetPaperSize(reportType: number): Promise<PaperSize> {
    var ret = await this.sendMsg({ Call: 'GetPaper', Args: { 'ReportType': reportType } });
    if (ret.Successed) {
      var r = ret.Returns as PaperSize;
      return r;
    }
    return null;
  }
  public async SelectFolder(path: string = ''): Promise<LocalFileInfo> {
    return await this.openSelectFiles(path, true);
  }
  public async SelectFiles(path: string = ''): Promise<LocalFileInfo> {
    return await this.openSelectFiles(path);
  }
  private async openSelectFiles(path: string = '', folderSelect: boolean = false): Promise<LocalFileInfo> {
    var ret = await this.sendMsg({ Call: 'GetFiles', Args: {} });
    var fileInfos = ret.Returns as LocalFileInfo
    var dg = this.matDialog.open(LocalFileSelectorComponent, {
      data: fileInfos,
      panelClass: 'before-loader',
      autoFocus: false,
      disableClose: true,
    });
    var promise = new Promise<LocalFileInfo>((rs, rj) => {
      dg.componentInstance.onClose.subscribe(() => {
        dg.componentInstance.onSelected.unsubscribe()
        dg.componentInstance.onClose.unsubscribe()
        dg.close();
        rs(null);
      });
      dg.componentInstance.onSelected.subscribe(x => {
        dg.componentInstance.onSelected.unsubscribe()
        dg.componentInstance.onClose.unsubscribe()
        dg.close();
        rs(x);
      });
      dg.componentInstance.trySetPath(path);
      dg.componentInstance.folderSelect = folderSelect;
    });
    var file = await promise;

    return file;
  }
  /** 取得檔案樹 */
  public async getFiles(): Promise<LocalFileInfo> {
    var ret = await this.sendMsg({ Call: 'GetFiles', Args: {} });
    var fileInfos = ret.Returns as LocalFileInfo
    return fileInfos;
  }
  /** 取得指定檔案(含Content) */
  public async getFullFiles(path: string = '', prefix: string = ''): Promise<LocalFileInfo> {
    var ret = await this.sendMsg({ Call: 'GetFullFiles', Args: { Path: path, PreFix: prefix } });
    if (!ret.Successed) {
      this.notificationService.showWarning(ret.Returns)
      return null;
    }
    var fileInfos = ret.Returns as LocalFileInfo
    return fileInfos;
  }
  /**
   * 取得指定ZIP檔案內容(含Content)
   * @param filePath 相對路徑 含檔名
   * @param pwd 密碼
   * @returns
   */
  public async GetZippedFiles(filePath: string, pwd: string): Promise<LocalFileInfo> {
    var ret = await this.sendMsg({ Call: 'GetZippedFiles', Args: { Path: filePath, Pwd: pwd } });
    if (!ret.Successed) {
      this.notificationService.showWarning(ret.Returns)
      return null;
    }
    var fileInfos = ret.Returns as LocalFileInfo
    return fileInfos;
  }
  public async getFullFilesAndMoveTo(path: string = '', moveTo: string): Promise<LocalFileInfo> {
    var ret = await this.sendMsg({ Call: 'GetFullFiles', Args: { Path: path, MoveTo: moveTo } });
    if (!ret.Successed) {
      this.notificationService.showWarning(ret.Returns)
      return null;
    }
    var fileInfos = ret.Returns as LocalFileInfo
    return fileInfos;
  }
  //#region  API SendFromUrl
  public async SendNHIUploadFromUrl(xmlString: string, type: 'A1' | 'A2' | 'ZZ'): Promise<{ RtnCode: string, Opcode: string }> {
    return await this.VisionApi.webApiUpload(xmlString, type)
    // var ra =   await this.VisionApi.GetVPNGetRandomXAndSignX('3','30');
    // var getHospID = await this.VisionApi.GetHospID();
    // var hospId = getHospID.Data;
    // var getSamid = await this.VisionApi.GetCardNoSAM();
    // var samid = getSamid.Data;

    // //  Base64 Encode btoa ; DeCode: atob
    // let base64EncodedString = btoa(xmlString);
    // let now = new Date();

    // let year = now.getFullYear();
    // let month = String(now.getMonth() + 1).padStart(2, '0');
    // let day = String(now.getDate()).padStart(2, '0');
    // let hours = String(now.getHours()).padStart(2, '0');
    // let minutes = String(now.getMinutes()).padStart(2, '0');
    // let seconds = String(now.getSeconds()).padStart(2, '0');
    // let milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    // let timestamp = `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
    // var input = {
    //     sSamid:samid,
    //     sHospid:hospId,
    //     sClientrandom:ra.Data.RandomX,
    //     sSignature:ra.Data.SignX,
    //     sPatData:base64EncodedString,
    //     sType:type,
    //     sUploadDT:timestamp,
    // }
    // let jsonContent = JSON.stringify(input)
    // let url = 'https://medvpndti.nhi.gov.tw/V1000/VNHI_Upload';
    // var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: jsonContent } });
    // return ret;
  }
  public async SendNHIDownloadFromUrl(type: 'A1' | 'A2' | 'ZZ', opcode: string) {
    return await this.VisionApi.webApiDownload(opcode, type);
    // var ra =   await this.VisionApi.GetVPNGetRandomXAndSignX('3','30');
    // var getHospID = await this.VisionApi.GetHospID();
    // var hospId = getHospID.Data;
    // var getSamid = await this.VisionApi.GetCardNoSAM();
    // var samid = getSamid.Data;

    // // //  Base64 Encode btoa ; DeCode: atob
    // // let base64EncodedString = btoa(xmlString);

    // var request = {
    //     sSamid: samid,
    //     sHospid:hospId,
    //     sClientrandom:ra.Data.RandomX,
    //     sSignature: ra.Data.SignX,
    //     sType: type,
    //     sOpcode:opcode,
    // }

    // let jsonContent = JSON.stringify(request)

    // let url = 'https://medvpndti.nhi.gov.tw/V1000/VNHI_Download';
    // var ret = await this.sendMsg({ Call: 'SendFromUrl', Args: { Url: url, Content: jsonContent } });
    // return ret;
  }

  //#endregion
  public async SendFromUrl(url: string, content: string, contentType: string, contentEncoding: string | number, headers: { [key: string]: string }, enableSlowStreaming: boolean = false) {
    var ret = await this.sendMsg({
      Call: 'SendFromUrl', Args: {
        Url: url,
        Content: content,
        ContentType: contentType,
        ContentEncoding: contentEncoding,
        Headers: headers,
        EnableSlowStreaming: enableSlowStreaming
      }
    });

    return ret;
  }

  public async PutFromUrl(url: string, content: string, contentType: string, contentEncoding: string | number, headers: { [key: string]: string }, enableSlowStreaming: boolean = false) {
    var ret = await this.sendMsg({
      Call: 'SendFromUrl', Args: {
        Url: url,
        Content: content,
        Method: 'PUT',
        ContentType: contentType,
        ContentEncoding: contentEncoding,
        Headers: headers,
        EnableSlowStreaming: enableSlowStreaming
      }
    });

    return ret;
  }
  public async GetFromUrl(url: string, headers: { [key: string]: string }) {
    var ret = await this.sendMsg({
      Call: 'SendFromUrl', Args: {
        Url: url,
        Content: '{}',
        Headers: headers,
        Method: 'GET'
      }
    });

    return ret;
  }
  public async DeleteFromUrl(url: string, headers: { [key: string]: string }) {
    var ret = await this.sendMsg({
      Call: 'SendFromUrl', Args: {
        Url: url,
        Content: '{}',
        Headers: headers,
        Method: 'DELETE'
      }
    });

    return ret;
  }
  /**
   *傳送WS訊息到主控台，寫入PACS的WorkList，建立PACS開單資料
   *
   * @param {PACSReceiver} data
   * @return {*}  {Promise<any>}
   * @memberof HcrService
   */
  public async SendPACSRequestToWorkList(data: PACSReceiver): Promise<any> {
    return await this.sendMsg({
      Call: "SendPACSRequestToWorkList",
      Args: data
    });
  }


  /**
   *傳送WS訊息到主控台，寫入PACS的WorkList，建立PACS健保上傳送資料
   *只有需要健保上傳時才需要呼叫

   * @param {PACSReceiver} data
   * @return {*}  {Promise<any>}
   * @memberof HcrService
   */
  public async SendPACSRequestToWorkList2(data: PACSReceiver): Promise<any> {
    return await this.sendMsg({
      Call: "SendPACSRequestToWorkList2",
      Args: data
    });
  }


  /** 傳送WS訊息到主控台，調用PACS Viewer，帶入病歷號參數
   *
   * @param patientNo 病歷號
   * @returns
   */
  public async CallPACSViewer(patientNo: string): Promise<any> {
    return await this.sendMsg({
      Call: "CallPACSViewer",
      Args: {
        PatientId: patientNo
      }
    });
  }

  /** 傳送WS訊息到主控台，調用其他廠牌PACS Viewer，帶入病歷號、姓名、生日、身分證字號參數
   * @param PACSCode 其他廠牌PACS識別碼，由主控台定義 (cliniview、sopro imaging、dimaxis、Morita、Apixia、Carestream、EasyDent4、eProImage、asahi等)
   * @param patientNo 病歷號
   * @param patientName 姓名
   * @param patientBirthday 生日 (yyyy/MM/dd)
   * @param patientCID 身分證字號 選擇性(dimaxis、Carestream、EasyDent4、eProImage、asahi 需要身分證字號才會顯示影像)
   * @param patFirstLetter 名字 (Carestream、EasyDent4 需要名字和姓氏分開才會顯示影像)
   * @param patLastLetter 姓氏 (Carestream、EasyDent4 需要名字和姓氏分開才會顯示影像)
   * @param patientSex 性別 (Carestream、EasyDent4、eProImage、asahi 需要有性別才會顯示影像(M:男 F:女))
   * @returns true 成功呼叫PACS Viewer，false失敗(可能是主控台版本過舊不支援此功能||其他錯誤訊息)
   */
  public async CallOtherPACSViewer(PACSCode: string, patientNo: string, patientName: string, patientBirthday: Date, patientCID?: string, patFirstLetter?: string, patLastLetter?: string, patientSex?: string): Promise<any> {
    console.log('CallOtherPACSViewer', PACSCode, patientNo, patientName, patientBirthday, patientCID, patFirstLetter, patLastLetter, patientSex);
    return await this.sendMsg({
      Call: "CallOtherPACSViewer",
      Args: {
        PACSCode: PACSCode,
        PatientNo: patientNo,
        PatientName: patientName,
        PatientBirthday: patientBirthday,
        PatientCID: patientCID,
        PatientFirstName: patFirstLetter,
        PatientLastName: patLastLetter,
        PatientSex: patientSex
      }
    });
  }

  public async CheckEdgeInstalled(): Promise<any> {
    return await this.sendMsg({
      Call: "CheckEdgeInstalled"
    });
  }

  demoPatient(): IPatient {
    return (this.VisionApi as VisionHisDemo).pat;
  }
  public setDemoMode(enable: boolean) {
    if (enable) {
      if (!this.demoApi) {
        this.demoApi = new VisionHisDemo(this.patientApi);
      }
      this.currentApi = this.VisionApi;
      this.setVisionApi(this.demoApi);
      // var p = new Patient();
      // p.Name = '展釋用';
      // p.CId = 'A987654321';
      // p.Sex = 'M';
      // //p.Age = 40;
      // p.Birthday = new Date(1966, 6, 6);
      // // this.patientApi.get('GetAll').subscribe(l=>{
      // //   console.log(l);
      // // });
      // demoApi.setCurrentPatient(p);
      this.demoApi.setClinic(UserCache.getLoginUser().Clinic);
      //demoApi.setDoctor(UserCache.getLoginUser().)
    } else {
      this.setVisionApi(this.currentApi);
    }
    this.isDemoMode = enable;
    this.consoleIconComponent.isHcrDemo = enable;
    this.consoleIconComponent.CsHisVer = this.IsVer6 ? '6'
      : this.IsVer5 ? '5' : ''

    this.hcrConsoleComp.isHcrDemo = enable;
    this.onDemoMode.emit(enable);
  }
  /** 隨機取時是否沿用同患者 */
  prevDemoPatientWhenRand = false;
  public async setDemoPatientExist() {
    if (this.isDemoMode) {
      if (this.prevDemoPatientWhenRand && this.hcrConsoleComp.demoPatient) {
        return;
      }
      var existPatient = await this.patientApi.GetRand();
      if (this.VisionApi instanceof VisionHisDemo) {
        this.VisionApi.setCurrentPatient(existPatient);
        this.hcrConsoleComp.demoPatient = existPatient;
      }
    }
  }
  // 展示模式還卡 for not Rand
  public async setDemoPatientExistNotRand(cid: string) {
    if (this.isDemoMode) {
      var existPatient = await this.patientApi.GetNotRand(cid);
      if (this.VisionApi instanceof VisionHisDemo) {
        this.VisionApi.setCurrentPatient(existPatient);
        this.hcrConsoleComp.demoPatient = existPatient;
      }
    }
  }
  public setDemoPatientNew() {
    if (this.isDemoMode) {
      var pat = this.randPatient();
      if (this.VisionApi instanceof VisionHisDemo) {
        this.VisionApi.setCurrentPatient(pat);
        this.hcrConsoleComp.demoPatient = pat;
      }
    }
  }
  public setDemoPatient(pat: IPatient) {
    if (this.isDemoMode) {
      if (this.VisionApi instanceof VisionHisDemo) {
        this.VisionApi.setCurrentPatient(pat);
        this.hcrConsoleComp.demoPatient = pat;
      }
    }
  }
  private randPatient(): PatientsDto {
    var p = new PatientsDto();
    p.CName = this.genName();
    var isMale = Math.random() > 0.5;
    p.Sex = isMale ? 1 : 0;
    p.CId = this.genCID(isMale);

    var birthYear = new Date().getFullYear() - Math.ceil(this.randn_bm(1, 100));
    var birthMonth = Math.ceil(Math.random() * 12);
    var birthDay = Math.ceil(Math.random() * 31);// 超過日期會自己往月份加
    p.Birthday = new Date(birthYear, birthMonth, birthDay);
    return p;
  }
  // 取得模擬常態分佈的數字
  private randn_bm(min, max, skew = 1) {
    let u = 0, v = 0;
    while (u === 0) u = Math.random() //Converting [0,1) to (0,1)
    while (v === 0) v = Math.random()
    let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v)

    num = num / 10.0 + 0.5 // Translate to 0 -> 1
    if (num > 1 || num < 0)
      num = this.randn_bm(min, max, skew) // resample between 0 and 1 if out of range

    else {
      num = Math.pow(num, skew) // Skew
      num *= max - min // Stretch to fill range
      num += min // offset to min
    }
    return num
  }
  private genName() {
    var firstName = ['李', '吳', '謝', '林', '孫', '黃', '王', '呂', '蘇', '陳', '彭', '郭', '鍾', '錢', '崔', '莊', '羅', '蕭', '白', '連', '梁', '楊', '施', '李', '劉', '廖', '葉', '簡', '邱', '張', '杜', '蔡', '顏', '韓', '鄭', '周', '姜', '何', '程', '夏', '房', '許', '茅', '黎', '傅', '賴', '丁', '洪', '胡', '繆', '鄧', '畢', '袁', '徐', '柳', '沈', '阮', '卞'];
    var lastName = ['育', '淑', '緯', '正', '佩', '宛', '佳', '南', '冠', '韻', '雅', '明', '慶', '逸', '喬', '婉', '怡', '姿', '原', '萬', '為', '珮', '柔', '俊', '彥', '國', '凱', '孟', '憲', '欣', '宜', '江', '辰', '容', '駿', '建', '志', '禹', '千', '添', '盈', '貞', '銘', '奕', '淳', '威', '至', '武', '合', '瑋', '君', '秀', '意', '惠', '馨', '秋', '詩', '幸', '惟', '政', '小', '玫', '心', '莉', '舒', '進', '柏', '家', '嬌', '竹', '筱', '羽', '少', '美', '乃', '昱', '麗', '蕙', '學', '韋', '一', '皓', '卉', '上', '偉', '曉', '啟', '炳', '依', '典', '昌', '馥', '書', '慧', '佑', '秉', '文', '敬', '興', '火', '兆', '承', '琬', '純', '信', '有', '旭', '茂', '哲', '耀', '玲', '陽', '筠', '宇', '嘉', '宥', '宣', '生', '珍', '璇', '琴', '均', '岑', '宏', '如', '雯', '蓁', '剛', '定', '香', '華', '婷', '男', '茵', '芸', '發', '月', '維', '琳', '州', '麟', '夫', '娟', '吉', '禾', '梅', '成', '珊', '貴', '凌', '群', '儀', '邦', '利', '丞', '榮', '以', '順', '豪', '英', '士', '青', '萍', '姍', '儒', '瑞', '亦', '虹', '盛', '誠', '玟', '綸', '任', '齊', '來', '萱', '伸', '琪', '伯', '雲', '恩', '倫', '隆', '桂', '新', '勳', '廷', '妏', '穎', '白', '松', '凡', '達', '恬', '冰', '瑄', '臻', '延', '賢', '全', '苓', '良', '東', '治', '枝', '真', '郁', '光', '仰', '中', '平', '菁', '然', '瑜', '敏', '倩', '蓉', '軒', '舜', '泉'];
    var name = firstName[Math.ceil(Math.random() * firstName.length)];
    name = name + lastName[Math.ceil(Math.random() * lastName.length)];
    // 10% 單名
    if (Math.random() > 0.1) {
      name = name + lastName[Math.ceil(Math.random() * lastName.length)];
    }
    return name;
  }
  private genCID(isMale: boolean) {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var temp = [];
    var charInd = Math.ceil(Math.random() * characters.length);
    temp.push(characters[charInd]);
    var calcTemp = 0;
    temp.push(isMale ? 1 : 2);
    for (var i = 0; i < 7; i++) {
      temp.push(Math.floor(Math.random() * 10));
    }
    var validCode = [1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11, 20, 48, 29, 38, 47, 56, 65, 74, 83, 21, 3, 12, 30]
    calcTemp = validCode[charInd];
    for (var i = 1; i <= 8; i++) {
      calcTemp += temp[i] * (9 - i);
    }
    temp.push(10 - calcTemp % 10);
    return temp.join('');
  }



  public async UploadLog(sData: Date, eDate: Date) {

    var ret = await this.sendMsg({
      Call: 'UploadLog', Args: {
        StartDate: sData,
        EndDate: eDate,
      }
    });
    return ret;
  }
  protocolSupport = false;
  openVisionHis(noUpdate: boolean = false): Promise<boolean> {
    var rs: (boolean) => void = null;
    var promise = new Promise<boolean>((_rs, _rj) => {
      rs = _rs
    });
    var onProtocolSupport = () => {
      window.removeEventListener('blur', onProtocolSupport);
      this.protocolSupport = true;
      rs(true);
    }
    window.addEventListener('blur', onProtocolSupport);
    setTimeout(() => {
      rs(false);
    }, 500);

    var p = BaseConfig.getConfig().webApi.hisBaseUrl;
    if (this.getChromeVersion() >= 130) {
      p = encodeURIComponent(p);
    }
    p = p + (noUpdate ? ";noupdate" : "");
    document.location.assign("visionhis://" + p);
    return promise;
  }

  public async SetPharPrinter(): Promise<string> {
    var u = UserCache.getLoginUser();
    var bc = BaseConfig.getConfig();
    var ret = await this.sendMsg({
      Call: 'SetPharPrinter', Args: {
        APP: window.location.origin,
        ServiceApi: bc.webApi.visionAuthUrl,
        CompanyCode: u.CompanyCode,
        ClinicCode: u.Clinic.Code
      }
    })
    if (ret.Successed) {
      return ret.Returns
    } else {
      this.notificationService.showError(ret.Returns)
      return '';
    }

  }
  async writeClientLog(logLevel: 'Error' | 'Warning' | 'Info', isSuccess: boolean, message: string) {
    const item = { logLevel, isSuccess, message, dt: new Date() };
    if (!this.canSendClientLogNow()) {
      this.enqueueClientLog(item);
      return;
    }

    const sent = await this.sendClientLog(item);
    if (!sent) {
      this.enqueueClientLog(item);
    } else {
      await this.flushPendingClientLogs();
    }
  }

  private canSendClientLogNow() {
    return !!this.ws && this.isConnected && this.ws.readyState === WebSocket.OPEN;
  }

  private enqueueClientLog(item: { logLevel: 'Error' | 'Warning' | 'Info', isSuccess: boolean, message: string, dt: Date }) {
    this.pendingClientLogs.push(item);
    if (this.pendingClientLogs.length > this.maxPendingClientLogs) {
      this.pendingClientLogs.splice(0, this.pendingClientLogs.length - this.maxPendingClientLogs);
    }
  }

  private async sendClientLog(item: { logLevel: 'Error' | 'Warning' | 'Info', isSuccess: boolean, message: string, dt: Date }) {
    try {
      const ret = await this.sendMsg({
        Call: 'WriteLog',
        Args: {
          Status: item.isSuccess,
          Level: item.logLevel,
          Message: item.message
        }
      });
      return ret?.Successed === true;
    } catch (ex) {
      return false;
    }
  }

  private async flushPendingClientLogs() {
    if (!this.canSendClientLogNow() || this.isFlushingClientLogs || this.pendingClientLogs.length === 0) {
      return;
    }

    this.isFlushingClientLogs = true;
    try {
      while (this.pendingClientLogs.length > 0 && this.canSendClientLogNow()) {
        const item = this.pendingClientLogs.shift();
        if (!item) {
          break;
        }
        const msgWithTs = `[${DateHelper.formatDateTime(item.dt)}]${item.message}`;
        const sent = await this.sendClientLog({ ...item, message: msgWithTs });
        if (!sent) {
          this.pendingClientLogs.unshift(item);
          break;
        }
      }
    } finally {
      this.isFlushingClientLogs = false;
    }
  }

  private installBrowserLifecycleLog() {
    if (this.browserLifecycleLogInstalled || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    this.browserLifecycleLogInstalled = true;
    this.logWsDiag('Info', true, 'browser-lifecycle-log-installed', {});

    document.addEventListener('visibilitychange', () => {
      this.logWsDiag('Info', true, 'browser-visibilitychange', {
        visibilityState: document.visibilityState,
        hidden: document.hidden
      });
    });

    window.addEventListener('online', () => {
      this.logWsDiag('Info', true, 'browser-online', {});
    });

    window.addEventListener('offline', () => {
      this.logWsDiag('Warning', false, 'browser-offline', {});
    });

    window.addEventListener('pagehide', (ev: PageTransitionEvent) => {
      this.logWsDiag('Warning', true, 'browser-pagehide', {
        persisted: ev?.persisted
      });
    });

    window.addEventListener('beforeunload', () => {
      this.logWsDiag('Warning', true, 'browser-beforeunload', {});
    });

    document.addEventListener('freeze', (() => {
      this.logWsDiag('Warning', true, 'browser-freeze', {});
    }) as EventListener);

    document.addEventListener('resume', (() => {
      this.logWsDiag('Info', true, 'browser-resume', {});
    }) as EventListener);
  }

  private logWsDiag(logLevel: 'Error' | 'Warning' | 'Info', isSuccess: boolean, event: string, data?: any) {
    const payload = {
      type: 'ws-diag',
      traceId: this.wsTraceId,
      event,
      at: new Date().toISOString(),
      wsReadyState: this.ws?.readyState,
      wsReadyStateText: this.getReadyStateText(this.ws?.readyState),
      isConnected: this.isConnected,
      autoReconnect: this.autoReconnect,
      reconnectInterval: this.reconnectInterval,
      locationHref: (typeof location !== 'undefined' ? location.href : ''),
      visibilityState: (typeof document !== 'undefined' ? document.visibilityState : ''),
      isOnline: (typeof navigator !== 'undefined' ? navigator.onLine : null),
      ...data
    };

    const msg = `[HCR-WS] ${JSON.stringify(payload)}`;
    this.writeClientLog(logLevel, isSuccess, msg).catch(() => { });
  }

  private trackHcrDisconnect(ev: CloseEvent, connectSeq: number, connectionOpenedAt: number) {
    const loginUser = UserCache.getLoginUser();
    if (!loginUser?.AuthToken) {
      this.resetHcrDisconnectMonitor();
      return;
    }

    const sessionKey = JSON.stringify([loginUser.CompanyCode, loginUser.Clinic?.Id, loginUser.UserId]);
    if (this.hcrDisconnectSessionKey !== sessionKey) {
      this.resetHcrDisconnectMonitor(sessionKey);
    }

    const now = Date.now();
    this.hcrDisconnectTimes = this.hcrDisconnectTimes.filter(time => now - time < this.hcrDisconnectWindowMs);
    this.hcrDisconnectTimes.push(now);
    if (this.hcrDisconnectTimes.length <= 8 ||
      this.hcrDisconnectNotifyCount >= this.maxHcrDisconnectNotifications ||
      (this.hcrDisconnectLastNotifyAt > 0 && now - this.hcrDisconnectLastNotifyAt < this.hcrDisconnectNotifyCooldownMs)) {
      return;
    }

    const consoleInfo: ConsoleInfo = this.localStorage.getItem('ConsoleInfo') ?? {};
    this.hcrDisconnectNotifyCount++;
    this.hcrDisconnectLastNotifyAt = now;
    try {
      this.debugApi.Notify({
        Event: 'HCR WebSocket 10分鐘內非預期斷線超過8次',
        At: new Date(now).toISOString(),
        TraceId: this.wsTraceId,
        ConnectSeq: connectSeq,
        DisconnectCountIn10Minutes: this.hcrDisconnectTimes.length,
        NotificationNumber: this.hcrDisconnectNotifyCount,
        CloseCode: ev.code,
        CloseReason: ev.reason,
        WasClean: ev.wasClean,
        ConnectedUptimeMs: now - connectionOpenedAt,
        CompanyCode: loginUser.CompanyCode,
        ClinicCode: loginUser.Clinic?.Code,
        ClinicName: loginUser.Clinic?.Name,
        UserId: loginUser.UserId,
        UserName: loginUser.Name,
        Account: loginUser.Account,
        ConsoleInfo: {
          Identity: consoleInfo?.Identity,
          ComputerName: consoleInfo?.ComputerName,
          IP: consoleInfo?.IP,
          Version: consoleInfo?.Version,
          InfoDate: consoleInfo?.InfoDate,
          DateTime: consoleInfo?.DateTime
        }
      });
    } catch (error) {
    }
  }

  private resetHcrDisconnectMonitor(sessionKey = '') {
    this.hcrDisconnectTimes = [];
    this.hcrDisconnectSessionKey = sessionKey;
    this.hcrDisconnectNotifyCount = 0;
    this.hcrDisconnectLastNotifyAt = 0;
  }

  private getReadyStateText(state?: number) {
    switch (state) {
      case WebSocket.CONNECTING: return 'CONNECTING';
      case WebSocket.OPEN: return 'OPEN';
      case WebSocket.CLOSING: return 'CLOSING';
      case WebSocket.CLOSED: return 'CLOSED';
      default: return `UNKNOWN(${state})`;
    }
  }
}

class IdGenerator {
  private current: number = 0;
  next() {
    this.current++;
    return this.current;
  }
}

export enum PrintProcessState {
  Income = 0,
  Processing = 1,
  Complete = 2,
}
export enum PrintProcessStep {
  Initial = 0,
  Loading = 1,
  TempPDF = 2,
  Printing = 3,
  Completing = 4,
  Complete = 5,
  Waiting = 98,
  Fail = 99,
}


export class MergePdfReport {
  reportNo: number;
  reportName: string;
  html: string;
  patientId: number;
}
export class PrintProgressModel {
  DocName: string;
  PrinterName: string;
  State: number;
  Step: number;
  Page: number;
  TotalPage: number;
  get StepDesc() {
    switch (this.Step) {
      case PrintProcessStep.Initial: return '初始化…';
      case PrintProcessStep.Loading: return '載入中…';
      case PrintProcessStep.TempPDF: return '處理中…';
      case PrintProcessStep.Printing: return '正在列印…';
      case PrintProcessStep.Completing: return '等候完成…';
      case PrintProcessStep.Complete: return '已完成';
      case PrintProcessStep.Fail: return '失敗';
      case PrintProcessStep.Waiting: return '閒置中';
      default: return '';
    }
  }
  get PageText() {
    if (this.Step == PrintProcessStep.Printing) {
      return `${this.Page}/${this.TotalPage}頁`;
    }
    return '---頁';
  }
  /**
   *
   */
  constructor(o: PrintProgressModel) {
    Object.assign(this, o)
  }

}
